<template>
<div class="chapter">
<div class="inner_page">
<p class="PT1" id="pt001"><a id="page_1"></a><a href="#/xhtml/contents#pt-001">PRELIMINARIES ON<br/>PHILOSOPHY AND FAITH</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?30ff2ac5